import {createActions} from 'client/framework';

export default createActions(null, ['SET_LAST_VALID_DATES']);
